'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Avatar_module = require('../styles/Avatar.module.less.js');
var SizeContext = require('./SizeContext.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description AvatarGroup component.
 *
 * @component
 * @example
 * ```jsx
 * <AvatarGroup size="m">
 *  <Avatar src="image.png" />
 *  <Avatar src="image.png" />
 * </AvatarGroup>
 * ```
 */
const AvatarGroup = React__namespace.forwardRef((props, ref) => {
    const { size, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Avatar_module.default);
    const classNames = cx(className, 'group');
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "AvatarGroup", className: classNames, ...restProps },
        React__namespace.createElement(SizeContext.SizeContextProvider, { size: size }, children)));
});
AvatarGroup.defaultProps = {
    size: 36,
};
AvatarGroup.displayName = 'AvatarGroup';

exports.AvatarGroup = AvatarGroup;
//# sourceMappingURL=AvatarGroup.js.map
